import styled from 'styled-components';

export const Container = styled.div`
  width: 100%;
  margin: 0 auto;
  text-align: center;
`;

export const DataContainer = styled.div`
  width: 100%;
  display: flex;
  justify-content: space-between;
`;

export const DonutContainer = styled.div`
  display: flex;
  justify-content: flex-start;
  width: 50%;
  height: 100%;
  padding: 20px;
`;

export const BreakdownContainer = styled.div`
  width: 50%;
`;




// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/styles.js